const ZIndexOrder = {
  drawer: 1000,
  modal: 1010,
  bottomSheet: 1020,
  dropdown: 1030,
  picker: 1035,
  notification: 1040,
  toast: 1050,
  popover: 1060,
  draggable: 1065,
  tooltip: 1070,
  tableFixedCol: 1,
} as const;

export type ZIndexOrder = keyof typeof ZIndexOrder;

export function getZIndex(order: ZIndexOrder) {
  return ZIndexOrder[order];
}
